import React, { Component } from 'react';

class SelectField extends Component {

  optionsList() {
    if (this.props.options) {
      return this.props.options.map((option) => {
        return (
          <option value={option.price} key={option.size} data-size={option.size}>
            {option.size} ({option.price} €)
          </option>
        );
      });
    }
  }

  render() {
    const selectedValeu = this.props.value;
    return (
      <select name={this.props.name} className={this.props.cssClass} value={selectedValeu}
        onChange={(e) => this.props.onChange(e, this.props.photo.file)}>
        {this.optionsList()}
      </select>
    );
  }
}

export default SelectField;


// WEBPACK FOOTER //
// ./src/components/Select.js